// JavaScript Document
// Version: 1.3.0

var pens               = minerva_common_vars.pens;
var deviceOrientation  = '';
var orientationChanged = false;



jQuery(document).ready(function($) {
	/**
	 * Inizializza il controllo "selectpicker".
	 *
	 * @since 1.0.0
	 */
	$('.selectpicker.nav-pills-home-tab-dropdown').selectpicker({
		style: 'btn-default btn-ghost',
		size: 'auto',
		width: '100%',
	});



	/**
	 * Imposta la proprietà "checked" a "true" se l'attributo "checked" è impostato a "checked".
	 * Tutte le operazioni Javascript dovranno quindi analizzare la PROPRIETA' "checked" e non più l'ATTRIBUTO.
	 *
	 * @since 1.0.0
	 */
	jQuery('input[checked="checked"]').prop('checked', true);



	/**
	 * Inizializza i tooltip.
	 *
	 * @since 1.1.0
	 */
	$('[data-toggle="tooltip"]').tooltip({
		boundary: 'window',
		placement: 'auto'
	});



	/**
	 * Inizializza le variabili per la gestione dell'animazione dell'header.
	 *
	 * @since 1.3.0
	 */
	var body = $('body');
	var primaryHeader, secondaryHeader, mobileNavPills, modelsSelectorWrapper, modelsSelector;

	if ( !body.hasClass('single-pen') && !body.hasClass('error404') && !body.hasClass('blog') && !body.hasClass('admin-page') ) {
		primaryHeader         = $('#primary-header');
		secondaryHeader       = $('#secondary-header');
		mobileNavPills        = $('.mobile-navpills-wrapper');
		modelsSelectorWrapper = $('#nav-pills-home-tab-dropdown-wrapper');
		modelsSelector        = $('.dropdown.bootstrap-select.nav-pills-home-tab-dropdown', modelsSelectorWrapper);
	}



	/**
	 * Gestisce lo "scroll to top".
	 *
	 * @since 1.1.0
	 */
	var offset       = 1000;
	var speed        = 250;
	var duration     = 500;
	var backToTopCtx = $('.back-to-top');

	$(window).scroll(function() {
		if ( $(this).scrollTop() < offset ) {
			backToTopCtx.fadeOut(duration);
		} else {
			backToTopCtx.fadeIn(duration);
		}
	});

	$('.topbutton').on('click', function() {
		backToTop(speed);
	});



	/**
     * Attiva una specifica tab in homepage in base al parametro eventualmente presente nell'url.
	 * Es. "https://configurator.prodir.com/en/#cloud-pens" permette di attivare la tab "Cloud Pens".
	 *
	 * ATTENZIONE
	 * All'interno del cookie "homeGroup" viene memorizzata la tab selezionata dall'utente; la presenza del paramentro nell'url deve avere la precedenza.
     *
	 * @since 1.3.0
     */
	if ( $('body').hasClass('home') ) {
		var url = window.location.href;

		if ( url.indexOf('#') > -1 ) {
			var group     = url.substring(url.indexOf("#") + 1);
			var isDesktop = $('body').hasClass('desktop');
			var isTablet  = $('body').hasClass('tablet') && $('body').hasClass('orientation-landscape');
			var groups    = [];

			jQuery('#v-pills-home-tab .nav-link').each(function(index, element) {
				groups.push(jQuery(element).data('group'));
			});

			if ( $.inArray(group, groups) > -1 ) {
				saveSelectedTab(group);
			}
		}
	}



	/**
     * Crea il cookie con il codice della lingua nel caso non esistesse.
     *
	 * @since 1.0.0
     */
	if ( !is_defined(Cookies.get('wp-wpml_current_language')) ) {
		var currentLang = $('html').attr('lang').split('-')[0];

		createCookie('wp-wpml_current_language', currentLang, 'session');
	}



    /**
	 * Intercetta il cambio della lingua.
	 *
	 * @since 1.0.0
	 */
	$('#language-menu li .dropdown-menu a').on('click', function() {
		var that                 = $(this);
		var selectedLangCode     = $('span', that).attr('lang');
		var cookieValue          = is_defined(Cookies.get('instance')) ? JSON.parse(Cookies.get('instance')) : {};

		cookieValue.languageCode = selectedLangCode;
		cookieValue              = JSON.stringify(cookieValue);

		if ( is_defined(Cookies.get('instance')) ) {
			updateCookie('instance', cookieValue);
		} else {
			createCookie('instance', cookieValue, 'session');
		}
	});



	/**
	 * Intercetta l'eventuale richiesta di una configurazione da parte del sito prodir.com.
	 *
	 * @since 1.0.0
	 */
	if ( urlParam('product') != null && urlParam('config') != null ) {
		displayLoading(true, 'load');

		var productId = parseInt(urlParam('product'));
		var nodeId    = parseInt(urlParam('config'));

		// Creo i cookie per tener traccia dei parametri anche dopo aver effettuato il redirect.
		createCookie('productId', productId, 'session');
		createCookie('nodeId', nodeId, 'session');

		// Se il productId fa riferimento ad una vecchia configurazione effettuo la conversione.
		if ( $.inArray(productId, oldProductIds) > -1 ) {
			productId = convertProductId(productId, nodeId);
		}

		// Effettuo il redirect alla pagina del modello di penna.
		if ( '' != pens[productId]['url'] ) {
			location.href = pens[productId]['url'];
		} else {
			var modal     = jQuery('#broken-modal');
			var str_intro = '<p>' + minerva_common_vars.missing_configuration_data.pen_model_intro + '</p>';
			var str       = '<p class="danger"><strong>' + minerva_common_vars.missing_configuration_data.pen_model + '</strong></p>';

			displayLoading(false, null);
			jQuery('.modal-body', modal).html(str_intro + str.replace('%s', pens[productId]['name']));
			modal.attr('data-action', 'redirect');
			modal.modal('show');
		}
	} else {
		if ( $('body').hasClass('home') ) {
			Cookies.remove('productId');
			Cookies.remove('nodeId');
		}
	}



	/**
	 * Rimanda alla homepage.
	 *
	 * @since 1.0.0
	 */
	$('#broken-modal').on('hidden.bs.modal', function (e) {
		if ( 'redirect' == $('#broken-modal').attr('data-action') ) {
			location.href = minerva_common_vars.homeurl + '/' + Cookies.get('wp-wpml_current_language');
		}
	});



	/**
	 * Memorizza la tab attiva al momento della selezione del modello di penna.
	 *
	 * @since 1.0.0
	 */
	$('#v-pills-home-tab a').on('click', function() {
		var that        = $(this);
		var group       = that.data('group');
		var optionValue = $('select.nav-pills-home-tab-dropdown option[data-group="' + group + '"]').attr('value');

		$('select.nav-pills-home-tab-dropdown').selectpicker('val', optionValue);

		saveSelectedTab(group);
		backToTop(speed);
	});

	// @since 1.3.0
	$('.nav-pills-home-tab-dropdown').on('change', function() {
		var that  = $(this);
		var group = $('option:selected', $(this)).data('group');

		saveSelectedTab(group);
		backToTop(speed);
	});



	/**
	 * Attiva la tab precedentemente selezionata.
	 *
	 * @since 1.0.0
	 */
	if ( is_defined(Cookies.get('homeGroup')) ) {
		activateTab();
	}



	/**
	 * Elimina i cookie.
	 *
	 * @since 1.0.0
	 */
	$('.remove-config-cookie').on('click', function() {
		Cookies.remove('productId');
		Cookies.remove('nodeId');
	});

	$('.remove-dealer-cookie').on('click', function() {
		Cookies.remove('dealer');
	});



	/**
	 * Rimuove la classe "hide-on-loading" una volta caricata la pagina.
	 *
	 * @since 1.1.0
	 */
	$('.hide-on-loading').removeClass('hide-on-loading');



	/**
	 * Chiude eventuali altre modal aperte.
	 *
	 * @since 1.1.0
	 */
	$('#response-modal').on('show.bs.modal', function() {
		$('.modal.show[id!="response-modal"]').each(function(index, element) {
			$('#' + $(element).attr('id')).modal('hide');
		});
	});



	/**
	 * Gestisce l'animazione dell'header.
	 *
	 * @since 1.1.0
	 */
	if ( body.hasClass('smartphone') || body.hasClass('tablet') ) {
		if ( window.innerWidth > window.innerHeight ) {
			body.addClass('orientation-landscape');
			deviceOrientation = 'landscape';
		} else {
			body.addClass('orientation-portrait');
			deviceOrientation = 'portrait';
		}
	}

	window.addEventListener('orientationchange', function() {
		var orientationAngle = window.orientation

		switch (window.orientation) {
			case -90:
			case 90:
				body.removeClass('orientation-portrait').addClass('orientation-landscape');
				deviceOrientation = 'landscape';
				break;
			case 0:
				body.removeClass('orientation-landscape').addClass('orientation-portrait');
				deviceOrientation = 'portrait';
				break;
		}

		orientationChanged = true;

		backToTop(speed);
		mobileNavPillsHandler(false, modelsSelector, modelsSelectorWrapper, secondaryHeader);
	}, false);

	if ( !body.hasClass('single-pen') && !body.hasClass('error404') && !body.hasClass('blog') && !body.hasClass('admin-page') ) {
		var article              = $('article.page');
		var lastScrollTop        = 0;
		var mobileNavPillsHeight = 61;

		var hidePrimaryHeader    = new Waypoint({
			element: article,
			handler: function(direction) {
				if ( 'down' === direction ) {
					body.addClass('primary-header-none');
				}
			},
			offset: 0
		});

		var showSecondaryHeader  = new Waypoint({
			element: article,
			handler: function(direction) {
				if ( 'down' === direction ) {
					body.addClass('secondary-header-block');
				}
			},
			offset: -10
		});

		var hideSecondaryHeader  = new Waypoint({
			element: article,
			handler: function(direction) {
				if ( 'up' === direction ) {
					body.removeClass('secondary-header-block');

					if ( 'portrait' == deviceOrientation ) {
						mobileNavPillsHandler(false, modelsSelector, modelsSelectorWrapper, secondaryHeader);
					}
				} else {

				}
			},
			offset: 60
		});

		if ( body.hasClass('smartphone') || ( body.hasClass('tablet') && body.hasClass('orientation-portrait') ) ) {
			var fixedMobileNavPills    = new Waypoint({
				element: mobileNavPills,
				handler: function(direction) {
					if ( 'down' === direction ) {
						if ( 'portrait' == deviceOrientation ) {
							mobileNavPillsHandler(true, modelsSelector, modelsSelectorWrapper, secondaryHeader);
						}
					}
				},
				offset: mobileNavPillsHeight
			});

			var relativeMobileNavPills = new Waypoint({
				element: article,
				handler: function(direction) {
					if ( 'up' === direction ) {
						if ( 'portrait' == deviceOrientation ) {
							mobileNavPillsHandler(false, modelsSelector, modelsSelectorWrapper, secondaryHeader);
						}
					} else {

					}
				},
				offset: -(mobileNavPillsHeight * 2)
			});
		}

		window.addEventListener("scroll", () => {
			const currentScroll     = window.pageYOffset || document.documentElement.scrollTop;
			var primaryHeaderHeight = (!body.hasClass('dealer') || (body.hasClass('dealer') && body.hasClass('secondary-header-block'))) ? 61 : 132;

			if ( currentScroll > primaryHeaderHeight && currentScroll > lastScrollTop ) {
				// downscroll
				body.addClass('primary-header-none');
			} else {
				// upscroll
				body.removeClass('primary-header-none');
			}

			lastScrollTop = currentScroll <= 0 ? 0 : currentScroll; // For Mobile or negative scrolling
		});
	}



	/**
	 * Gestisce l'apertura e la chiusura del footer secondario sui dispositivi mobili, quando l'utente naviga in "modalità dealer".
	 *
	 * @since 1.1.0
	 */
	$('.btnExpand').click(function() {
		var that            = $(this);
		var footer          = that.closest('#site-footer');
		var icon            = $('i', that);
		var iconClassOpen   = that.data('class-open');
		var iconClassClosed = that.data('class-closed');

		if ( footer.hasClass('open') ) {
			footer.removeClass('open').addClass('closed');
			icon.removeClass(iconClassOpen).addClass(iconClassClosed);
		} else {
			footer.removeClass('closed').addClass('open');
			icon.removeClass(iconClassClosed).addClass(iconClassOpen);
		}
	});



	/**
	 * Gestisce il pannello dei credits.
	 *
	 * @since 1.1.0
	 */
	var creditsPanel = $('#credits-panel');

	$('.btn-open-credits').click(function(event) {
		event.preventDefault();
		creditsPanel.removeClass('closed').addClass('open');
	});

	$('.btn-close-credits').click(function(event) {
		event.preventDefault();
		creditsPanel.removeClass('open').addClass('closed');
	});



	/**
	 * Gestisce la selezione delle tab in homepage.
	 *
	 * @since 1.1.0
	 */
	$('.nav-pills-home-tab-dropdown').on('show.bs.select', function (e, clickedIndex, isSelected, previousValue) {
		$('#v-pills-home-tabContent').addClass('standby');
	});

	$('.nav-pills-home-tab-dropdown').on('hidden.bs.select', function (e, clickedIndex, isSelected, previousValue) {
		$('#v-pills-home-tabContent').removeClass('standby');
	});

	$('.nav-pills-home-tab-dropdown').on('changed.bs.select', function (e, clickedIndex, isSelected, previousValue) {
		var tabId = $('option:selected', $(this)).data('href');
		var group = $('option:selected', $(this)).data('group');

		$('.tab-pane.tab-products.active').removeClass('active');
		$(tabId).addClass('active');
		$('#v-pills-home-tabContent').removeClass('standby');
		$('#v-pills-home-tab a.active').removeClass('active');
		$('#v-pills-home-tab a[data-group="' + group + '"]').addClass('active');
	});



	$(window).unload(function() {
		//$.cookies.del('dealer');
		//Cookies.remove('dealer');
	});



	/**
	 * Gestisce l'altezza dell'iframe di Iubenda.
	 *
	 * @since 1.1.0
	 */
	$('div[id^="iubenda-"].modal').on('shown.bs.modal', function() {
		var that            = $(this);
		var modalBody       = $('.modal-body', that);
		var modalBodyHeight = modalBody.height();

		$('iframe', modalBody).css('height', (modalBodyHeight + 80 + 30) + 'px');
	});


	/**
	 * Gestisce l'apertura delle modal da link.
	 *
	 * @since 1.1.0
	 */
	$('.nav-link.data-target-modal').each(function(index, element) {
		$(element).on('click', function(e) {
			e.preventDefault();

			var classes = $(element).attr('class').split(' ');

			$.each(classes, function(index, element) {
				if ( element.indexOf('target-') == 0 ) {
					var modalId = element.replace('target-', '');

					$('#' + modalId).modal('show');

					return false;
				}
			});
		});
	});



	/**
	 * Permette di attivare le tab in homepage tramite pulsanti.
	 * L'attributo "href" del pulsante deve corrispondere all'"id" del link corrispondente alla tab da attivare.
	 *
	 * @since 1.2.0
	 */
	$('a.btn[href^="#v-pills"]').on('click', function() {
		var id = $(this).attr('href').replace('#', '');

		$('#v-pills-home-tab a[id="' + id + '"]').trigger('click');
	});



	/**
	 * Inizializza il controllo "selectpicker".
	 *
	 * @since 2.7.0
	 */
	$('.quantity-currency-selector .selectpicker').selectpicker({
		style: 'btn-default btn-ghost',
		size: 'auto',
		// width: '100%',
	});




});





/*
 * Restituisce true se "element" esiste, altrimenti false.
 *
 * @param {*} element : può essere un qualsiasi elemento del DOM o un cookie
 *
 * @since 1.0.0
 */
function is_defined(element) {
	return ( typeof element !== typeof undefined );
}



/*
 * Crea un cookie.
 *
 * @param {string} 	   name  : nome del cookie
 * @param {*} 		   value : valore del cookie
 * @param {int|string} life  : durata/scadenza (se di tipo int corrisponde al numero di giorni, se di tipo string accetta "session" o stringa vuota)
 *
 * @since 1.0.0
 */
function createCookie(name, value, life) {
	if ( life == 'session' || life == '' ) {
		// Se il cookie deve essere un cookie di sessione è necessario omettere il parametro "expires".
		Cookies.set(name, value, { sameSite: 'None', secure: true });
	} else {
		Cookies.set(name, value, { sameSite: 'None', secure: true, expires: life });
	}
}


/*
 * Aggiorna un cookie.
 *
 * @since 1.0.0
 */
function updateCookie(name, value) {
	Cookies.set(name, value, { sameSite: 'None', secure: true });
}



/**
 * Converte eventuali caratteri nelle corrispondenti entità HTML.
 *
 * @param  {string} str : stringa di testo
 *
 * @return {string}
 *
 * @since 1.0.0
 */
function htmlEntities(str) {
	return String(str).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
}



/**
 * Converte un colore da RGB a HEX.
 *
 * @param  {string} orig : valore in formato RGB
 *
 * @return {string}
 *
 * @since 1.0.0
 */
function rgb2hex(orig) {
	var rgb = orig.replace(/\s/g,'').match(/^rgba?\((\d+),(\d+),(\d+)/i);

	return (rgb && rgb.length === 4) ? "#" +
		("0" + parseInt(rgb[1],10).toString(16)).slice(-2) +
		("0" + parseInt(rgb[2],10).toString(16)).slice(-2) +
		("0" + parseInt(rgb[3],10).toString(16)).slice(-2) : orig;
}



/**
 * Restituisce la rotazione di un elemento in DEG anziché come MATRIX.
 *
 * @param  {object} "obj" : selettore
 *
 * @return {int}
 *
 * @since 1.0.0
 */
function getRotationDegrees(obj) {
	var matrix = obj.css("-webkit-transform") || obj.css("-moz-transform") || obj.css("-ms-transform") || 	obj.css("-o-transform") || obj.css("transform");

	if ( matrix !== 'none' ) {
		var values = matrix.split('(')[1].split(')')[0].split(',');
		var a = values[0];
		var b = values[1];
		var angle = Math.round(Math.atan2(b, a) * (180/Math.PI));
	} else {
		var angle = 0;
	}

	return ( angle < 0 ) ? angle +=360 : angle;
}



/**
 * Effettua la validazione dei campi delle modal-popup.
 *
 * @param  {element} ctx : contesto di validazione
 *
 * @return {bool}
 *
 * @since 1.0.0
 */
function customValidation(ctx) {
	var validationResult = true;

	jQuery('.form-control', ctx).each(function(index, element) {
		var field           = jQuery(this);
		var fieldCtx        = field.closest('.form-group');
		var validationRoles = field.data('validation').split(',');
		var errorMessages   = new Array();

		jQuery.each( validationRoles, function( i, val ) {
			switch ( val ) {
				case 'required':
					if ( field.val() == '' ) {
						errorMessages.push(minerva_common_vars.required_field);
						validationResult = false;
					}
					break;
			}
		});
		if ( errorMessages.length > 0 ) {
			jQuery('.validation', fieldCtx).html(errorMessages.join('. ')).show();
			fieldCtx.addClass('error');
		} else {
			jQuery('.validation', fieldCtx).html('').hide();
			fieldCtx.removeClass('error');
		}
	});

	return validationResult;
}



/**
 * Imposta il messaggio di errore da mostrare nella modal-popup.
 *
 * @param  {object} xhr      :
 * @param  {string} ctx      : contesto dalla modal
 * @param  {string} errorCtx : contesto in cui si è verificato l'errore
 *
 * @since 1.0.0
 */
function showErrorMessage(xhr, ctx, errorCtx) {
	var status          = xhr.status;
	var statusText      = xhr.statusText;
	var response        = ( xhr.responseJSON != null ) ? xhr.responseJSON : 'null';
	var responseText    = ( xhr.responseText != '' ) ? xhr.responseText : '';
	var message         = ( 'null' != response) ? response.message : responseText;
	var str             = '<p class="text-secondary mb-0">Status: ' + status;
	var courtesyMessage = is_defined(xhr.courtesyMessage) ? xhr.courtesyMessage : minerva_common_vars.error_courtesy_message;

	if ( is_defined(statusText) &&  '' != statusText ) {
		str += '<br>Status text: ' + statusText;
	}

	if ( is_defined(message) && '' != message ) {
		str += '<br>Message: ' + message + '</p>';
	} else {
		str += '</p>';
	}

	jQuery('.primary-content', ctx).html(str);
	jQuery('.secondary-content', ctx).html('<p class="text-secondary">' + courtesyMessage + '</p>');
	jQuery(ctx).modal('show');

	jQuery.ajax({
		type: 'POST',
		dataType: 'json',
		url: minerva_common_vars.ajaxurl,
		data: {
			action: 'minerva_log_file',
			xhr: {
				status: status,
				statusText: statusText,
				response: response,
				responseText: responseText,
				errorCtx: is_defined(errorCtx) ? errorCtx : ''
			}
		},
		success: function(response) {

		},
		error: function(error)  {
			console.log(error);
		}
	});
}



/**
 * Effettua la conversione del productId di una vecchia configurazione.
 *
 * @param  {string} productId : ID del modello di penna nel vecchio configuratore
 * @param  {int}    nodeId    : ID del nodo Drupal corrispondente alla configurazione salvata
 *
 * @return {int}
 *
 * @since 1.0.0
 */
function convertProductId(productId, nodeId) {
	// "productIds" è un array con gli ID dei modelli di penna ai quali corrispondono in realtà più modelli differenti:
	//    - DS2 e DS2 Metal nose cone.
	//    - DS3, DS3 Bioric e DS3 Mechanical pencil.
	//    - DS8 e DS8 Mechanical pencil.
	//    - DS9 e DS9 Metal nose cone.
	var productIds   = ['2325', '1128', '49413', '50000'];
	var languageCode = Cookies.get('wp-wpml_current_language');

	return mapping[productId.toString()].modelId[languageCode];
}



/**
 * Effettua l'intersezione tra più array.
 *
 * @param {array} arrays : array contenente gli array da intersecare
 *
 * @since 1.0.0
 */
function arrayIntersect(arrays) {
	var result = arrays.shift().filter(function(v) {
		return arrays.every(function(a) {
			return a.indexOf(v) !== -1;
		});
	});

	return result;
}



/**
 * Crea un GUID.
 *
 * @since 1.0.0
 */
function createGuid() {
	function S4() {
		return ( ( ( 1 + Math.random() ) * 0x10000) | 0 ).toString(16).substring(1);
	}

	return (S4() + S4() + "-" + S4() + "-4" + S4().substr(0,3) + "-" + S4() + "-" + S4() + S4() + S4()).toLowerCase();
}



/**
 * Arrotonda un numero secondo le regole generali.
 *
 * @param {float} number   : numero da arrotondare
 * @param {int}   decimals : numero di decimali
 *
 * @since 1.0.0
 */
function roundNumber(number, decimals) {
	return (Math.round(number * Math.pow(10, decimals)) / Math.pow(10, decimals));
}



/**
 * Recupera eventuali parametri passati via query string nell'url.
 *
 * @param  {string} name : chiave della query string da recuperare
 *
 * @return {*}           : valore associato alla chiave della query string
 *
 * @since 1.0.0
 */
function urlParam(name) {
	var results = new RegExp('[\?&]' + name + '=([^&#]*)').exec(window.location.href);

	return ( results == null ) ? null : results[1] || 0;
}



/**
 * Formatta le credenziali di accesso per la Basic authentication.
 *
 * @param  {object} loginData : JSON con le credenziali di accesso
 *
 * @return {string}
 *
 * @since 1.1.0
 */
function formatBasicAuth(loginData) {
	var basicAuthCredential = loginData.name + ":" + loginData.pass;
	var base64              = btoa(basicAuthCredential);

	return 'Basic ' + base64;
}



/**
 * Gestisce l'overlay con il loading.
 *
 * @param {bool}   show :
 * @param {string} type : definisce quale messaggio mostrare
 *
 * @since 1.1.0
 */
function displayLoading(show, type) {
	if ( is_defined(type) && null != type) {
		var loadingText;

		switch (type) {
			case 'init':
				//loadingText = 'Connecting to prodir.com';
				loadingText = 'Loading';
				break;
			case 'token':
				loadingText = 'Getting token';
				break;
			case 'connect':
				loadingText = 'Checking user';
				break;
			case 'login':
				loadingText = 'Logging in';
				break;
			case 'logout':
				loadingText = 'Logging out';
				break;
			case 'save':
				loadingText = 'Saving configuration';
				break;
			case 'load':
				loadingText = 'Loading configuration';
				break;
			case 'download':
				loadingText = 'Generating preview';
				break;
			case 'redirect':
				loadingText = 'Redirecting to prodir.com';
				break;
			case 'initConfigurator':
				//loadingText = 'Configurator initialization';
				loadingText = 'Initializing';
				break;
		}

		jQuery('.overlay.fullscreen p').text(loadingText);
	} else {
		jQuery('.overlay.fullscreen p').text('');
	}

	if (show) {
		jQuery('.overlay.fullscreen').show();
	} else {
		jQuery('.overlay.fullscreen').hide();
	}
}



/**
 * Gestisce il mobileNavPills.
 *
 * @param {bool}     fixed       : "true" se la select deve comparire nell'header (quindi risultare fissa), altrimenti "false"
 * @param {selector} child       :
 * @param {selector} parent      :
 * @param {selector} fixedParent :
 *
 * @since 1.1.0
 */
function mobileNavPillsHandler(fixed, child, parent, fixedParent) {
	if ( is_defined(fixedParent) ) {
		if ( fixed ) {
			fixedParent.addClass('fat');
			jQuery('.row', fixedParent).append(child);
		} else {
			fixedParent.removeClass('fat');
			jQuery(parent).append(jQuery(child));
		}
	}
}



/**
 * Effettua lo scroll verso la testa della pagina.
 *
 * @param {int} speed :
 *
 * @since 1.3.0
 */
function backToTop(speed) {
	jQuery('html, body').animate({
		scrollTop: 0
	}, speed);
	return false;
}



/**
 * Attiva la tab in base al valore memorizzato nel cookie.
 *
 * @since 1.3.0
 */
function activateTab() {
	var selectedTab = Cookies.get('homeGroup');

	jQuery('select.nav-pills-home-tab-dropdown').selectpicker('val', selectedTab);
	jQuery('#v-pills-home-tab a[data-group="' + selectedTab + '"]').trigger('click');
}



/**
 * Salva la tab selezionata in un cookie.
 *
 * @param {string} group :
 *
 * @since 1.3.0
 */
function saveSelectedTab(group) {
	if ( !is_defined(Cookies.get('homeGroup')) ) {
		createCookie('homeGroup', group, 'session');
	} else {
		updateCookie('homeGroup', group);
	}
}



/**
 * Scrive nel file di log.
 *
 * @param {array}    data     :
 * @param {function} callback :
 *
 * @since 2.2.0
 */
function _log(data, callback) {
	jQuery.ajax({
		type: 'POST',
		dataType: 'json',
		url: minerva_common_vars.ajaxurl,
		data: {
			action: 'minerva_log_file',
			xhr: data
		},
		success: function(response) {
			callback();
		},
		error: function(error)  {
			console.log(error);
		}
	});
}
